import Header from 'employees/components/list/EmployeesListHeader';
import Filters from 'employees/components/list/EmployeesListFilters';
import Table from 'employees/components/list/EmployeesListTable';
import Row from 'employees/components/list/EmployeesListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/list/index.js